export default {
	'add-new-user': '',
	'the-user': '',
	users: '',
	confirm: '',
	activate: '',
	deactivate: '',
	'are-you-sure-you-want-to-$-this-user': '',
	'user-state-is-changed-successfully': ''
}